import axios from "axios";
import { useEffect, useState } from "react";
import Products from "../../Components/Products/Products";
import "./ProductList.css";

const ProductListWithoutCache = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    async function fetchdata() {
      const {
        data: { entries },
      } = await axios.get("https://api.publicapis.org/entries");
      setData(entries);
    }
    fetchdata();
  }, []);
  if (!data.length)
    return (
      <>
        {!data.length && (
          <p className='h1 d-flex justify-content-center mt-10 h-full items-center'>
            Loading...
          </p>
        )}
      </>
    );
  return (
    <div className='productlist bg-orange-300'>
      {data &&
        data.map((item: any) => (
          <Products key={item.Link} item={item}></Products>
        ))}
    </div>
  );
};
export default ProductListWithoutCache;
